/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import Backbone from 'backbone';
import i18n from '../../../../i18n/DashboardBundle.properties';
import templateEditHyperlinkParameter from '../template/EditHyperlinkParameterTemplate.htm';

export default Backbone.View.extend({
    template: _.template(templateEditHyperlinkParameter),
    tagName: 'tr',
    className: 'edit',
    initialize: function (attrs, options) {
        options = options || {};
        this.editMode = options.editMode;
        this.render();
        this.originalModelValues = this.model.toJSON();
        this.listenTo(this.model, 'validated', this._onValidated);
    },
    events: {
        'click .save.button': '_save',
        'click .cancel.button': '_cancel'
    },
    render: function () {
        this.$el.html(this.template(_.extend({}, this.model.attributes, {i18n: i18n})));
        return this;
    },
    _save: function () {
        var values = this._getValues();
        this.model.set(values, {validate: true});
        if (this.model.isValid()) {
            this.trigger(this.editMode ? 'edit' : 'add', this, this.model);
        }
    },
    _onValidated: function () {
        if (this.model.validationError && this.model.validationError.name) {
            this.$('td.name').addClass('error');
            this.$('td.name .warning').removeClass('hidden');
        } else {
            this.$('td.name').removeClass('error');
            this.$('td.name .warning').addClass('hidden');
        }
        if (this.model.validationError && this.model.validationError.value) {
            this.$('td.value').addClass('error');
            this.$('td.value .warning').removeClass('hidden');
        } else {
            this.$('td.value').removeClass('error');
            this.$('td.value .warning').addClass('hidden');
        }
    },
    _getValues: function () {
        return {
            name: this.$('input[name=\'name\']').val(),
            value: this.$('input[name=\'value\']').val()
        };
    },
    _cancel: function () {
        this.trigger('cancel', this, this.model, this.originalModelValues);
    }
});